module.exports = __webpack_public_path__ + "static/img/2.b5d1207.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/channel/dingtalk/2.png
// module id = P5as
// module chunks = 1